import React, { Component } from 'react';
import Breadcrumb from '../components/Breadcrumb';
import CustomTabv2 from '../components/custom/CustomTabv2';
import WatchlistIndividualSearchComponent from '../components/kyc/watchlist/WatchlistIndividualSearchComponent';
import WatchlistEntitySearchComponent from '../components/kyc/watchlist/WatchlistEntitySearchComponent';
import {
  WatchlistConfiguration,
  WatchlistEntityRequest,
  WatchlistGeneralRequest,
  WatchlistIndividualRequest,
  WatchlistListsModel,
} from '../domain/watchlist/WatchlistDomains';
import { WatchlistPageTab } from '../constant/Constants';
import { FormicaProps, withFormica } from '../helpers/withFormica';
import MessageUtil from '../util/MessageUtil';
import { store } from '../redux/store';
import { initialPagePath } from '../redux/reducers/PageReducer';
import ComponentName from '../constant/ComponentName';
import FolderService from '../service/FolderService';
import WatchlistConfigurationComponent from '../components/kyc/watchlist/WatchlistConfigurationComponent';
import WatchlistSettingsComponent from '../components/kyc/watchlist/WatchlistSettingsComponent';
import WatchlistHistoryComponent from '../components/kyc/watchlist/WatchlistHistoryComponent';
import WatchlistListLogComponent from '../components/kyc/watchlist/WatchlistListLogComponent';
import Icon from '../icons/Icon';
import { query, repository, subscribe } from '@trlogic/client-js';
import WatchlistService from '../service/WatchlistService';
import ServiceContainer from '../config/ServiceContainer';
import { ServiceNames } from '../constant/ServiceNames';
import { InstanceContainer } from '../config/binding/InstanceBinding';
import Injectables from '../constant/Injectables';
import CollectionNames from '../constant/CollectionNames';
import WatchlistGeneralSearchComponent from '../components/kyc/watchlist/WatchlistGeneralSearchComponent';
import { ConfirmPopup } from 'primereact/confirmpopup';
import LanguageUtil from '../util/LanguageUtil';
import WatchlistUtil from '../util/WatchlistUtil';

class WatchlistContainer extends Component<Props, State> {
  public state: State = new State();
  private computation: subscribe.Computation | undefined;
  private watchlistConfigurationSubscription: subscribe.Subscription | undefined;

  private repository: repository.ReadOnlyQueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);
  private watchlistService: WatchlistService = ServiceContainer.getInstance().get(ServiceNames.WATCHLIST);

  public render() {
    const { type } = this.state;
    return (
      <div className='w-full h-full flex flex-col overflow-y-hidden'>
        <Breadcrumb />
        <ConfirmPopup />
        <div className={'p-5'}>
          <div className={'flex justify-between'}>
            <div className={'flex'}>
              <span
                key={'icon'}
                className='w-[60px] h-[60px] min-h-[60px] min-w-[60px] 2xl:w-[80px] 2xl:h-[80px] 2xl:min-h-[80px] 2xl:min-w-[80px] flex justify-center items-center rounded-[50%] bg-[#EFF2FE] mr-1'
              >
                {type == 'General' ? (
                  <img src={'/icons/general.svg'} alt='individual' />
                ) : type == 'Individual' ? (
                  <img src={'/icons/individual.svg'} alt='individual' />
                ) : type == 'Entity' ? (
                  <img src={'/icons/entity.svg'} alt='entity' />
                ) : (
                  <Icon icon={'configuration'} className={'text-f-purple'} size={32} />
                )}
              </span>
              <div className={'flex flex-col justify-center pl-3'}>
                <span className={'text-[24px] 2xl:text-4xl font-normal'}>{this.getPageTitle()}</span>
                <span className={'text-md font-normal !text-f-black-3'}>{this.getPageDescription()}</span>
              </div>
            </div>
          </div>
        </div>
        <div className={'flex flex-col overflow-y-scroll h-full w-full'}>
          <CustomTabv2 tab={this.getTabs()} onClick={(e, tab: string) => this.setState({ type: tab as WatchlistPageTab })} />
        </div>
      </div>
    );
  }

  public async componentDidMount() {
    const {
      router: { location },
    } = this.props;
    const page = store.getState().page;
    const initial = initialPagePath[ComponentName.WATCHLIST];
    if (page.pagePath.length == 0 || page.pagePath[0].title != initial?.title) {
      await FolderService.calculate('WITHOUT_FOLDER', ComponentName.WATCHLIST, location.pathname, store.getState().page);
    }
    const lists: WatchlistListsModel[] | undefined = await this.watchlistService.getLists();
    this.setState({ lists: lists || [] });
    this.startTracker();
  }

  public componentWillUnmount() {
    this.stopTracker();
  }

  protected startTracker = () => {
    const watchlistConfigurationQuery = query.QueryBuilder.select().from(CollectionNames.WATCHLIST_CONFIGURATION).build();
    this.watchlistConfigurationSubscription = subscribe.Formica.subscribe(CollectionNames.WATCHLIST_CONFIGURATION, watchlistConfigurationQuery);
    this.computation = subscribe.Tracker.autorun(this.tracker, [this.watchlistConfigurationSubscription]);
  };

  protected stopTracker = async () => {
    await this.watchlistConfigurationSubscription?.stop();
    this.computation?.stop();
  };

  protected tracker = async () => {
    if (this.watchlistConfigurationSubscription?.ready()) {
      const watchlistConfigurationQuery = query.QueryBuilder.select().from(CollectionNames.WATCHLIST_CONFIGURATION).build();
      const watchlistConfiguration: WatchlistConfiguration[] = await this.repository.findMany(watchlistConfigurationQuery);
      this.setState({
        watchlistConfiguration: watchlistConfiguration,
      });
    }
  };

  private search = async () => {
    const { searchRequest } = this.state;
    const {
      router: { navigate },
    } = this.props;
    const check = this.emptyCheck();
    if (check) return;
    if (searchRequest)
      try {
        this.setState({ requestLoading: true });
        const url = this.calculateUrl();
        if (url == undefined) return;
        navigate(url);
      } catch (e) {
        console.error(e);
      } finally {
        this.setState({ requestLoading: false });
      }
  };

  private calculateUrl = () => {
    const { searchRequest, type } = this.state;
    const urlParams = new URLSearchParams();
    urlParams.set('type', type);
    searchRequest.threshold && urlParams.set('threshold', searchRequest.threshold.toString());
    searchRequest.name && urlParams.set('name', searchRequest.name);
    searchRequest.email && urlParams.set('email', searchRequest.email);
    searchRequest.phone && urlParams.set('phone', searchRequest.phone);
    searchRequest.lists && urlParams.set('lists', searchRequest.lists.join(','));
    if (type == 'Individual') {
      (searchRequest as WatchlistIndividualRequest).dateOfBirth &&
        urlParams.set('dateOfBirth', (searchRequest as WatchlistIndividualRequest).dateOfBirth?.toString() as string);
      (searchRequest as WatchlistIndividualRequest).identification &&
        urlParams.set('identification', (searchRequest as WatchlistIndividualRequest).identification as string);
      (searchRequest as WatchlistIndividualRequest).citizenship &&
        urlParams.set('citizenship', (searchRequest as WatchlistIndividualRequest).citizenship as string);
      (searchRequest as WatchlistIndividualRequest).referenceId &&
        urlParams.set('referenceId', (searchRequest as WatchlistIndividualRequest).referenceId as string);
    } else if (type == 'Entity') {
      (searchRequest as WatchlistEntityRequest).identifier && urlParams.set('identifier', (searchRequest as WatchlistEntityRequest).identifier as string);
      (searchRequest as WatchlistEntityRequest).dateOfRegistration &&
        urlParams.set('dateOfRegistration', (searchRequest as WatchlistEntityRequest).dateOfRegistration?.toString() as string);
      (searchRequest as WatchlistEntityRequest).referenceId &&
        urlParams.set('referenceId', (searchRequest as WatchlistEntityRequest).referenceId as string);
    } else if (type == 'General') {
      (searchRequest as WatchlistGeneralRequest).id && urlParams.set('id', (searchRequest as WatchlistGeneralRequest).id as string);
      (searchRequest as WatchlistGeneralRequest).date && urlParams.set('date', (searchRequest as WatchlistGeneralRequest).date?.toString() as string);
      (searchRequest as WatchlistGeneralRequest).referenceId &&
        urlParams.set('referenceId', (searchRequest as WatchlistGeneralRequest).referenceId as string);
    }
    return `/watchlist/list/${urlParams.toString()}`;
  };

  private emptyCheck = () => {
    const { searchRequest, type } = this.state;
    const name = searchRequest.name;
    const id =
      type == 'Individual'
        ? (searchRequest as WatchlistIndividualRequest).identification
        : type == 'Entity'
          ? (searchRequest as WatchlistEntityRequest).identifier
          : (searchRequest as WatchlistGeneralRequest).id;
    if (searchRequest.threshold == 0 || searchRequest.threshold == undefined) {
      MessageUtil.error({
        summary: LanguageUtil.get({ id: 'pages.watchlist.title', defaultMessage: 'Watchlist' }),
        detail: LanguageUtil.get({ id: 'pages.watchlist.emptyCheckDetailThreshold', defaultMessage: 'Threshold value cannot be empty and 0!' }),
      });
      return true;
    }
    if ((name == undefined || name == '' || name.trim().length == 0) && (id == undefined || id == '' || id.trim().length == 0)) {
      MessageUtil.error({
        summary: LanguageUtil.get({ id: 'pages.watchlist.title', defaultMessage: 'Watchlist' }),
        detail: LanguageUtil.get({ id: 'pages.watchlist.emptyCheckDetailName', defaultMessage: 'Name and Id value cannot be empty!' }),
      });
      return true;
    }
    return false;
  };

  private onChangeRequest = (searchRequest: Partial<WatchlistIndividualRequest | WatchlistEntityRequest | WatchlistGeneralRequest>) => {
    this.setState({ searchRequest });
  };

  protected getTabs = () => {
    const { searchRequest, requestLoading, watchlistConfiguration, lists } = this.state;
    const searchableLists = lists.filter((list: WatchlistListsModel) => list.size > 0 || WatchlistUtil.isCustomList(list));
    return [
      {
        key: 'General',
        label: LanguageUtil.get({ id: 'common.tabs.general', defaultMessage: 'General' }),
        content: (
          <WatchlistGeneralSearchComponent
            searchRequest={searchRequest as WatchlistGeneralRequest}
            onChangeRequest={this.onChangeRequest}
            watchlistConfiguration={watchlistConfiguration}
            requestLoading={requestLoading}
            lists={searchableLists}
            search={() => this.search()}
          />
        ),
      },
      {
        key: 'Individual',
        label: LanguageUtil.get({ id: 'common.tabs.individual', defaultMessage: 'Individual' }),
        content: (
          <WatchlistIndividualSearchComponent
            searchRequest={searchRequest as WatchlistIndividualRequest}
            onChangeRequest={this.onChangeRequest}
            watchlistConfiguration={watchlistConfiguration}
            requestLoading={requestLoading}
            lists={searchableLists}
            search={() => this.search()}
          />
        ),
      },
      {
        key: 'Entity',
        label: LanguageUtil.get({ id: 'common.tabs.entity', defaultMessage: 'Entity' }),
        content: (
          <WatchlistEntitySearchComponent
            searchRequest={searchRequest as WatchlistEntityRequest}
            onChangeRequest={this.onChangeRequest}
            watchlistConfiguration={watchlistConfiguration}
            requestLoading={requestLoading}
            lists={searchableLists}
            search={() => this.search()}
          />
        ),
      },
      {
        key: 'Configuration',
        label: LanguageUtil.get({ id: 'common.tabs.configuration', defaultMessage: 'Configuration' }),
        content: (
          <div className={'flex flex-col w-full h-full overflow-y-auto'}>
            <WatchlistSettingsComponent />
            <WatchlistConfigurationComponent watchlistConfiguration={watchlistConfiguration} lists={lists} />
          </div>
        ),
      },
      {
        key: 'History',
        label: LanguageUtil.get({ id: 'common.tabs.history', defaultMessage: 'History' }),
        content: <WatchlistHistoryComponent />,
      },
      {
        key: 'ListLog',
        label: LanguageUtil.get({ id: 'common.tabs.listLog', defaultMessage: 'List Log' }),
        content: <WatchlistListLogComponent lists={lists} />,
      },
    ];
  };

  private getPageTitle = (): string => {
    const { type } = this.state;
    switch (type) {
      case 'General':
      case 'Individual':
      case 'Entity':
        return LanguageUtil.get({ id: 'pages.watchlist.screening', defaultMessage: 'Watchlist Screening' });
      case 'History':
        return LanguageUtil.get({ id: 'pages.watchlist.history.title', defaultMessage: 'Watchlist History' });
      case 'ListLog':
        return LanguageUtil.get({ id: 'pages.watchlist.listLog.title', defaultMessage: 'Watchlist List Log' });
      case 'Configuration':
      default:
        return LanguageUtil.get({ id: 'pages.watchlist.config', defaultMessage: 'Watchlist Configuration' });
    }
  };

  private getPageDescription = (): string => {
    return LanguageUtil.get({ id: 'pages.watchlist.searchInstructions', defaultMessage: 'Fill in the input fields below to get information' });
  };
}

interface Props extends FormicaProps {}

class State {
  searchRequest: Partial<WatchlistIndividualRequest | WatchlistEntityRequest | WatchlistGeneralRequest> = {};
  requestLoading: boolean = false;
  type: WatchlistPageTab = 'General';
  watchlistConfiguration: WatchlistConfiguration[] = [];
  lists: WatchlistListsModel[] = [];
}

export default withFormica(WatchlistContainer);
